import { Trans } from '@lingui/macro';
import React from 'react';
import Avatar from '../../../component/Avatar';

const ToolTipStaffRank = ({ item }) => {
  const { x, y, name, avatar } = item;
  return (
    <div style={{ fontSize: 13, padding: 5 }}>
      <div className={'flex-start-row'}>
        <Avatar user={{ avatar }} size={40} />
        <div>{name}</div>
      </div>
      <div>
        <Trans>Khách hàng:</Trans>&nbsp;{y}
      </div>
      <div>
        <Trans>Rate:</Trans>&nbsp;{x}
      </div>
    </div>
  );
};

export default ToolTipStaffRank;
